import { launchReach } from './launch-reach';
import { showMessage } from './display';

async function main(): Promise<void> {
  try {
    await launchReach();
  } catch (err) {
    const message = err instanceof Error ? err.message : 'Failed to initialize Reach';
    showMessage(`Error: ${message}`, true);
  }
}

main();
